import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  Paper,
} from "@mui/material";
import logo from "../../../assets/agility-logo.png";
import { IconButton, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import api from "../../../services/api";
import "./ConsultationInvoice.css";

const GenerateInvoice = () => {
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const slug = params.get("slug");

  useEffect(() => {
    generateInvoiceDetails(slug);
  }, [slug]);

  const generateInvoiceDetails = async (slug) => {
    let response = await api.get(`app/invoice/${slug}`);

    if (response?.status === 200) {
      setInvoiceDetails(response?.data);
    }
  };
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const year = String(date.getFullYear()).slice(-2); // last two digits
    return `${day}-${month}-${year}`;
  };
  function getDayName(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { weekday: "long" });
  }

  const handleDownload = async () => {
    const invoice = document.getElementById("invoiceContent");

    // Wait for all images in the invoice to fully load
    const waitForImages = (container) => {
      const imgs = container.querySelectorAll("img");
      return Promise.all(
        Array.from(imgs).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = img.onerror = resolve;
          });
        }),
      );
    };

    await waitForImages(invoice);

    // Capture invoice with html2canvas
    const canvas = await html2canvas(invoice, {
      scale: 3, // 10 is too heavy; 3 is sufficient
      useCORS: true, // Allow cross-origin images
      logging: false,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth(); // 210 mm for A4
    const imgProps = pdf.getImageProperties(imgData);
    const pdfHeight = (imgProps.height * pageWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pdfHeight);
    pdf.save("invoice.pdf");
  };
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(amount || 0);
  return (
    <>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
          className="icon-hover-actions"
        >
          <Tooltip title="Download">
            <IconButton onClick={handleDownload}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <Box
          sx={{
            width: "800px",
            p: 4,
            mt: 3,
            backgroundColor: "#fff",
            boxShadow: 3,
            borderRadius: 2,
          }}
          id="invoiceContent"
          className="invoice_box"
        >
          <Typography variant="h6" align="center" fontWeight="bold">
            INVOICE
          </Typography>
          {/* Download Button */}
          <Grid container spacing={2} mt={4}>
            <Grid size={8}>
              <Box>
                <img
                  src={logo}
                  alt="Logo"
                  style={{ width: "100px", height: "auto" }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={1}>
            <Grid size={8}>
              <Box>
                <Typography variant="body2" className="previewincoice_text">
                  {invoiceDetails?.invoice_data?.branch_name}
                </Typography>
                <Typography variant="body2" className="previewincoice_text">
                  {invoiceDetails?.invoice_data?.address +
                    " " +
                    invoiceDetails?.invoice_data?.country}
                </Typography>
                <Typography variant="body2" className="previewincoice_text">
                  {invoiceDetails?.invoice_data?.city +
                    " - " +
                    invoiceDetails?.invoice_data?.postal_code}
                </Typography>
                <Typography variant="body2" className="previewincoice_text">
                  {invoiceDetails?.invoice_data?.contact_number}
                </Typography>
              </Box>
            </Grid>

            <Grid
              size={4}
              sx={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
              }}
            >
              <Box>
                <Typography className="previewinvoice_text2">
                  <strong>Name</strong>: {invoiceDetails?.invoice_data?.name}
                </Typography>
                <Typography className="previewinvoice_text2">
                  <strong>Age</strong>: {invoiceDetails?.invoice_data?.age} Year
                </Typography>
                <Typography className="previewinvoice_text2">
                  <strong>Date</strong>:{" "}
                  {invoiceDetails?.published_at !== null
                    ? invoiceDetails?.published_at
                    : formatDate(new Date())}
                </Typography>
                <Typography className="previewinvoice_text2">
                  <strong>Attended Slots</strong>:
                  {invoiceDetails?.invoice_data?.records?.session_count}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <TableContainer component={Paper} elevation={0}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="invoicetablecell-text">
                    <strong>Service</strong>
                  </TableCell>
                  <TableCell className="invoicetablecell-text">
                    <strong>Day</strong>
                  </TableCell>
                  <TableCell className="invoicetablecell-text">
                    <strong>Date</strong>
                  </TableCell>
                  <TableCell className="invoicetablecell-text">
                    <strong>Total</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(
                  invoiceDetails?.invoice_data?.records?.sessions,
                ) &&
                  invoiceDetails?.invoice_data?.records?.sessions.map(
                    (row, idx) => (
                      <TableRow key={idx}>
                        <TableCell className="tablebody-text">
                          {row.service_name}
                        </TableCell>
                        <TableCell className="tablebody-text">
                          {getDayName(row.session_date)}
                        </TableCell>
                        <TableCell className="tablebody-text">
                          {formatDate(row.session_date)}
                        </TableCell>
                        <TableCell className="tablebody-text">
                          {row.therapy_fee}
                        </TableCell>
                      </TableRow>
                    ),
                  )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Totals */}
          <Box mt={5} display="flex" justifyContent="flex-end">
            <Box width="300px">
              <Typography
                display="flex"
                justifyContent="space-between"
                variant="body2"
              >
                <span>Subtotal</span>
                <span>
                  {formatCurrency(
                    invoiceDetails?.invoice_data?.records?.total_amount,
                  )}
                </span>
              </Typography>

              <Typography
                display="flex"
                justifyContent="space-between"
                variant="body2"
              >
                <span>Discount</span>
                <span>0</span>
              </Typography>

              <Divider sx={{ my: 1 }} />

              <Typography
                display="flex"
                justifyContent="space-between"
                variant="h6"
                fontWeight="bold"
              >
                <span>Grand Total</span>
                <span>
                  {formatCurrency(
                    invoiceDetails?.invoice_data?.records?.total_amount,
                  )}
                </span>
              </Typography>
            </Box>
          </Box>

          {/* Footer */}
          <Box mt={10} textAlign="center">
            <Typography variant="body2" color="text.secondary">
              Thank you for choosing {invoiceDetails?.branch_name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              This is a computer-generated invoice.
            </Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default GenerateInvoice;
